// Mock data for NOZEN FLASHER website

export const businessInfo = {
  name: "NOZEN FLASHER",
  tagline: "Solusi Android Profesional",
  phone: "0858-5903-0899",
  whatsappLink: "https://wa.me/6285859030899",
  telegram: "@NozenMods",
  telegramLink: "https://t.me/nozenmods",
  address: {
    street: "Jl. Kali Baru",
    district: "Mekarsari, Kec. Tambun Selatan",
    city: "Kabupaten Bekasi, Jawa Barat 17510"
  },
  rating: 5.0,
  totalReviews: 85,
  operationalHours: "Buka setiap hari – Tutup pukul 20.00 WIB",
  serviceAreas: ["Bekasi", "Tambun", "Cibitung", "Cikarang"],
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.7063!2d107.0489!3d-6.2897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwMTcnMjIuOSJTIDEwN8KwMDInNTYuMCJF!5e0!3m2!1sen!2sid!4v1234567890",
  mapLink: "https://maps.app.goo.gl/hhxKRNugCEKizXF5A"
};

export const services = [
  {
    id: 1,
    title: "Root Android",
    subtitle: "Semua Merek",
    description: "Buka akses penuh ke sistem Android Anda. Mendukung semua merek dan tipe smartphone.",
    features: ["Akses root tanpa batas", "Backup data aman", "Garansi proses"]
  },
  {
    id: 2,
    title: "Flash Android",
    subtitle: "Bootloop, Error Sistem, Mati Total",
    description: "Perbaiki masalah software Android yang bootloop, stuck logo, atau mati total.",
    features: ["Recovery bootloop", "Perbaikan sistem error", "Restore factory"]
  },
  {
    id: 3,
    title: "Unlock Bootloader",
    subtitle: "Buka Akses Sistem",
    description: "Buka bootloader untuk memaksimalkan potensi smartphone Android Anda.",
    features: ["Proses resmi & aman", "Support berbagai merek", "Panduan lengkap"]
  },
  {
    id: 4,
    title: "Custom ROM",
    subtitle: "Performa Maksimal",
    description: "Install custom ROM untuk meningkatkan performa dan fitur smartphone.",
    features: ["ROM terbaru & stabil", "Optimasi baterai", "Fitur tambahan"]
  },
  {
    id: 5,
    title: "Module Magisk & LSPosed",
    subtitle: "Gacor & Mod Aplikasi",
    description: "Install Module Magisk, LSPosed, dan Mod Gacor untuk Gojek Indonesia, GoFood, Grab Indonesia, GrabFood, InDriver, Maxim Indonesia.",
    features: ["Modul Gacor Ojol", "LSPosed Framework", "Hide Root Detection"]
  },
  {
    id: 6,
    title: "Servis Software",
    subtitle: "Android Umum",
    description: "Layanan servis software Android umum untuk berbagai masalah dan kebutuhan.",
    features: ["Hapus FRP/Google", "Bypass pattern", "Update sistem"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Teknisi Berpengalaman",
    description: "Tim teknisi kami memiliki pengalaman bertahun-tahun dalam menangani berbagai masalah Android."
  },
  {
    id: 2,
    title: "Proses Aman & Transparan",
    description: "Setiap proses dikerjakan dengan aman dan transparan. Anda bisa memantau langsung prosesnya."
  },
  {
    id: 3,
    title: "Harga Terjangkau",
    description: "Kami menawarkan harga kompetitif dan transparan tanpa biaya tersembunyi."
  },
  {
    id: 4,
    title: "Respon Cepat",
    description: "Konsultasi gratis dan respon cepat untuk setiap pertanyaan dan keluhan Anda."
  },
  {
    id: 5,
    title: "Area Layanan Luas",
    description: "Melayani wilayah Bekasi, Tambun, Cibitung, dan Cikarang dengan layanan berkualitas."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Andi Pratama",
    location: "Bekasi",
    rating: 5,
    comment: "HP Samsung saya yang bootloop berhasil diperbaiki dengan cepat. Terima kasih NOZEN FLASHER!",
    date: "2 minggu lalu"
  },
  {
    id: 2,
    name: "Dewi Sartika",
    location: "Tambun",
    rating: 5,
    comment: "Proses root cepat dan aman. Teknisinya ramah dan profesional. Recommended!",
    date: "1 bulan lalu"
  },
  {
    id: 3,
    name: "Budi Santoso",
    location: "Cikarang",
    rating: 5,
    comment: "Custom ROM yang diinstall membuat HP saya lebih kencang. Sangat puas dengan hasilnya!",
    date: "1 bulan lalu"
  },
  {
    id: 4,
    name: "Rina Wulandari",
    location: "Cibitung",
    rating: 5,
    comment: "HP Xiaomi yang brick bisa diselamatkan. Awalnya sudah pasrah, ternyata bisa hidup lagi!",
    date: "2 bulan lalu"
  }
];

export const navLinks = [
  { id: 1, label: "Beranda", href: "#beranda" },
  { id: 2, label: "Layanan", href: "#layanan" },
  { id: 3, label: "Mengapa Kami", href: "#mengapa-kami" },
  { id: 4, label: "Ulasan", href: "#ulasan" },
  { id: 5, label: "Kontak", href: "#kontak" }
];
